import { createElement } from "react";
import * as react from "react";
import { Interop_reactApi } from "../../.fable/Feliz.1.43.0/Interop.fs.js";
import { reactFlow } from "../../.fable/Feliz.ReactFlow.0.2.0/Interop.fs.js";
import { some } from "../../.fable/fable-library.3.1.2/Option.js";
import { fixDocsView, code } from "../../Shared.fs.js";
import { ofArray } from "../../.fable/fable-library.3.1.2/List.js";

export const flowChart = react.createElement("div", {
    style: {
        height: 150,
    },
}, Interop_reactApi.createElement(reactFlow, {
    elements: [{
        id: "1",
        type: "input",
        data: {
            label: "Erdgas Einsatz",
        },
        style: {
            background: "yellow",
            color: "#332",
            border: "1px solid #222138",
            width: 180,
        },
        position: {
            x: 20,
            y: 5,
        },
    }, {
        id: "2",
        type: "default",
        data: {
            label: "CityCube",
        },
        style: {
            background: "#2e88c9",
            color: "white",
            border: "1px solid #222138",
            width: 180,
        },
        position: {
            x: 250,
            y: 15,
        },
    }, {
        id: "3",
        type: "output",
        data: {
            label: "Strom Absatz",
        },
        style: {
            background: "lightblue",
            color: "#333",
            border: "1px solid #222138",
            width: 180,
        },
        position: {
            x: 100,
            y: 100,
        },
    }, {
        id: "4",
        type: "output",
        data: {
            label: "Wärme Absatz",
        },
        style: {
            background: "red",
            color: "white",
            border: "1px solid #222138",
            width: 180,
        },
        position: {
            x: 100,
            y: 100,
        },
    }, {
        id: "e1-2",
        source: "1",
        target: "2",
        animated: false,
        label: "100 MWh",
        type: "smoothstep",
        arrowHeadType: "arrowclosed",
        style: {
            stroke: "yellow",
        },
        labelStyle: {
            fill: "black",
            fontWeight: 700,
        },
    }, {
        id: "e2-3",
        source: "2",
        target: "3",
        animated: true,
        label: "50 MWh",
        type: "smoothstep",
        arrowHeadType: "arrowclosed",
        style: {
            stroke: "blue",
        },
        labelStyle: {
            fill: "blue",
            fontWeight: 700,
        },
    }, {
        id: "e2-4",
        source: "2",
        target: "4",
        animated: true,
        label: "55 MWh",
        type: "smoothstep",
        arrowHeadType: "arrowclosed",
        style: {
            stroke: "red",
        },
        labelStyle: {
            fill: "red",
            fontWeight: 700,
        },
    }],
    onElementClick: (delegateArg0, delegateArg1) => {
        console.log(some(delegateArg1));
        window.alert(some("You clicked me!"));
    },
    onNodeDragStop: (delegateArg0_1, delegateArg1_1) => {
        console.log(some(delegateArg1_1));
        window.alert(some("You dragged me!"));
    },
    onElementsRemove: (elements_1) => {
        console.log(some(elements_1));
        window.alert(some("You removed me!"));
    },
    onConnect: (element_1) => {
        console.log(some(element_1));
        window.alert(some("You connected me!"));
    },
    onConnectStart: (delegateArg0_2, delegateArg1_2) => {
        console.log(some(delegateArg1_2));
        window.alert(some("You started to connect me!"));
    },
}));

export const overview = (() => {
    let elms_1;
    const children_2 = ofArray([createElement("h1", {
        className: "title is-1",
        children: Interop_reactApi.Children.toArray(["Feliz.ReactFlow Example"]),
    }), (elms_1 = ofArray([createElement("p", {
        children: ["Here is an example how to use ReactFlow"],
    }), flowChart, code("\r\n                ReactFlow.flowChart [\r\n                    ReactFlow.elements [|\r\n                        ReactFlow.node [\r\n                            node.id \"1\"\r\n                            node.nodetype Input\r\n                            node.data {| label = \"Erdgas Einsatz\" |}\r\n                            node.style [\r\n                                style.background \"yellow\"\r\n                                style.color \"#332\"\r\n                                style.border \"1px solid #222138\"\r\n                                style.width 180\r\n                            ]\r\n                            node.position (20, 5)\r\n                        ]\r\n                        ReactFlow.node [\r\n                            node.id \"2\"\r\n                            node.nodetype Default\r\n                            node.data {| label = \"CityCube\" |}\r\n                            node.style [\r\n                                style.background \"#2e88c9\"\r\n                                style.color \"white\"\r\n                                style.border \"1px solid #222138\"\r\n                                style.width 180\r\n                            ]\r\n                            node.position (250, 5)\r\n                        ]\r\n                        ReactFlow.node [\r\n                            node.id \"3\"\r\n                            node.nodetype Output\r\n                            node.data {| label = \"Strom Absatz\" |}\r\n                            node.style [\r\n                                style.background \"lightblue\"\r\n                                style.color \"#333\"\r\n                                style.border \"1px solid #222138\"\r\n                                style.width 180\r\n                            ]\r\n                            node.position (100, 100)\r\n                        ]\r\n                        ReactFlow.node [\r\n                            node.id \"4\"\r\n                            node.nodetype Output\r\n                            node.data {| label = \"Wärme Absatz\" |}\r\n                            node.style [\r\n                                style.background \"red\"\r\n                                style.color \"white\"\r\n                                style.border \"1px solid #222138\"\r\n                                style.width 180\r\n                            ]\r\n                            node.position (100, 100)\r\n                        ]\r\n                        ReactFlow.edge [\r\n                            edge.id \"e1-2\"\r\n                            edge.source \"1\"\r\n                            edge.target \"2\"\r\n                            edge.animated false\r\n                            edge.label \"100 MWh\"\r\n                            edge.edgeType SmoothStep\r\n                            edge.arrowHeadType ArrowClosed\r\n                            edge.style [ style.stroke \"yellow\" ]\r\n                            edge.labelStyle [\r\n                                labelStyle.fill \"black\"\r\n                                labelStyle.fontWeight 700\r\n                            ]\r\n                        ]\r\n                        ReactFlow.edge [\r\n                            edge.id \"e2-3\"\r\n                            edge.source \"2\"\r\n                            edge.target \"3\"\r\n                            edge.animated true\r\n                            edge.label \"50 MWh\"\r\n                            edge.edgeType SmoothStep\r\n                            edge.arrowHeadType ArrowClosed\r\n                            edge.style [ style.stroke \"blue\" ]\r\n                            edge.labelStyle [\r\n                                labelStyle.fill \"blue\"\r\n                                labelStyle.fontWeight 700\r\n                            ]\r\n                        ]\r\n                        ReactFlow.edge [\r\n                            edge.id \"e2-4\"\r\n                            edge.source \"2\"\r\n                            edge.target \"4\"\r\n                            edge.animated true\r\n                            edge.label \"55 MWh\"\r\n                            edge.edgeType SmoothStep\r\n                            edge.arrowHeadType ArrowClosed\r\n                            edge.style [ style.stroke \"red\" ]\r\n                            edge.labelStyle [\r\n                                labelStyle.fill \"red\"\r\n                                labelStyle.fontWeight 700\r\n                            ]\r\n                        ]\r\n                    |]\r\n                    ReactFlow.onElementClick\r\n                        (fun (x, y) -\u003e\r\n                            console.log y\r\n                            window.alert \"You clicked me!\")\r\n                    ReactFlow.onNodeDragStop\r\n                        (fun (x, y) -\u003e\r\n                            console.log y\r\n                            window.alert \"You dragged me!\")\r\n                    ReactFlow.onElementsRemove\r\n                        (fun (x, y) -\u003e\r\n                            console.log y\r\n                            window.alert \"You removed me!\")\r\n                    ReactFlow.onConnect\r\n                        (fun (x, y) -\u003e\r\n                            console.log y\r\n                            window.alert \"You connected me!\")\r\n                    ReactFlow.onConnectStart\r\n                        (fun (x, y) -\u003e\r\n                            console.log y\r\n                            window.alert \"You started to connect me!\")\r\n                ]\r\n                ")]), createElement("div", {
        className: "content",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    })), fixDocsView("FelizReactFlow.ExampleFlow", false)]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    });
})();

